
export const apisbasic = {

  accounttype: {
    service:{
      name:'accounttype',
      title:'Account Type',
    }
  },

  apitype: {
    service:{
      name:'apitype',
      title:'API Type',
    }
  },

  providertype: {
    service:{
      name:'providertype',
      title:'Provider Type',
    }
  },
};
